export const hy = {
  title: 'Ծառերի ծածկոցի բարձրություն',
  subtitle: '2000/2020, 30 m, global, UMD/NASA GEDI',
  download_data: '',
  learn_more: 'https://glad.umd.edu/dataset/gedi/',
  content: [
    {
      label: 'Գործառույթ',
      value: 'Ցույց տվեք համաշխարհային անտառային կանեփի բարձրությունը 2000 եւ 2020 թվականներին:',
    },
    {
      label: 'Բանաձեւ',
      value: '30 մ',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: 'Գլոբալ, 52°N-ից բարձր նախատիպային տվյալներով',
    },
    {
      label: 'Աղբյուր',
      value:
        'Potapov, P., Li, X., Hernandez-Serna, A., Tyukavina, A., Hansen, M.C., Kommareddy, A., Pickens, A., Turubanova, S., Tang, H., Silva, C.E. and Armston, J., 2021. Mapping global forest canopy height through integration of GEDI and Landsat data. Remote Sensing of Environment, 253, p.112165. https://doi.org/10.1016/j.rse.2020.112165',
    },
    {
      label: 'Հաճախականություն',
      value: '',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: '2000 եւ 2020',
    },
    {
      label: 'Զգուշացումներ',
      value:
        'Անտառների համաշխարհային բարձրության քարտեզը նախատիպային արտադրանք է, որը հայտնի է GEDI տվյալների որակի եւ Landsat տվյալների մատչելիության հետ կապված խնդիրներով: GEDI-ի տվյալները գերագնահատում են անտառների բարձրությունը բարեխառն եւ մերձարեւադարձային լեռնային մարգագետինների լանջերին, օրինակ՝ Նոր Զելանդիայում եւ Լեսոթոյում։ Քաղաքների եւ արվարձանների վրա ծառի բարձրությունը կարող է շփոթել շենքի բարձրության հետ, քանի որ GEDI-ի տվյալները չեն խտրականություն դնում բուսական եւ մարդու կողմից ստեղծված առարկաների բարձրության միջեւ։ Քարտեզի որոշ սխալների համար կարող են պատասխանատու լինել GEDI-ի (մասնավորապես, գեոլոկացիոն ճշգրտության եւ ցամաքի մակերեւույթի բարձրության գնահատման) անորոշությունները։ Ծառի բարձրության մոդելը հագեցվել է 30մ-ից բարձր եւ կարող է բավարար չափով չներկայացվել ամենաբարձր ծառերի բարձրությանը: Համաշխարհային արտադրանքը կթարմացվի ապագայում, որպեսզի լուծի խնդիրների մեծ մասը:',
    },
    {
      label: 'Լիցենզիա',
      value: '',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      '30-մ տարածական նոր բանաձեւով մշակվեց անտառների կանոպիի համաշխարհային բարձրության քարտեզը Գլոբալ էկոլոգիական դինամիկայի հետազոտության (GEDI) լիդարային անտառների կառուցվածքի չափորոշիչների եւ Landsat analysis-ready data time-series-ի միավորման միջոցով: NASA GEDI-ն տիեզերական լիդարային գործիք է, որը գործում է միջազգային տիեզերական կայանում 2019 թվականի ապրիլից: Այն ապահովում է բուսականության կառուցվածքի կետերի վրա հիմնված չափումներ, ներառյալ անտառային կանեփի բարձրությունը ամբողջ աշխարհում 52°N-ից մինչեւ 52°S: Մերիլենդի համալսարանի (UMD GLAD) Global Land Analysis and Discover թիմը համախմբել է մինչեւ օրս առկա GEDI տվյալները (2019թ. ապրիլ-հոկտեմբեր) 2019 թվականի Landat վերլուծության-պատրաստի ժամանակի-սերիայի տվյալների (Landsat ARD) հետ: GeDI RH95 -ը (հարաբերական բարձրությունը 95%) մետրիկն օգտագործվել է մոդելը չափելու համար։ Լանդսատի բազմժամանակյա չափումները, որոնք ներկայացնում են մակերեսային ֆենոլոգիան, ծառայում են որպես համաշխարհային անտառային բարձրության մոդելավորման անկախ փոփոխականներ: Գործարկվեց տեղանքում չափված եւ կիրառված ռեգրեսիայի ծառերի համաժողովի մոդելը, որը կապահովեր անտառների բարձրության կանխատեսման եւ համաշխարհային քարտեզի հետեւողականության բարձր որակը: Մոդելը վերարտադրվել է բորենային շրջաններում (GEDI տվյալների շարքից այն կողմ)՝ ստեղծելու անտառների բարձրության համաշխարհային նախատիպային քարտեզը։',
  },
  citation: {
    label: 'Մեջբերում',
    value:
      'Potapov, P., Li, X., Hernandez-Serna, A., Tyukavina, A., Hansen, M.C., Kommareddy, A., Pickens, A., Turubanova, S., Tang, H., Silva, C.E. and Armston, J., 2021. Mapping global forest canopy height through integration of GEDI and Landsat data. Remote Sensing of Environment, 253, p.112165. https://doi.org/10.1016/j.rse.2020.112165. Accessed through Global Forest Watch on 14/02/2025. www.globalforestwatch.org.',
  },
};
